import Vue from 'vue'
import Vuex from 'vuex'
import { setToken, removeToken, setUser, getUser } from '@/utils/auth'
import { login, getUserInfo, mobileLogin } from '@/api/auth'

Vue.use(Vuex)

function computeRole(user) {
  if (!user) return null
  const roleCodes = (user.roleCodes || []).map(c => (c || '').toUpperCase())
  return (roleCodes.includes('MAINT_ADMIN') || user.roleCode === 'SUPER_ADMIN') ? 'admin' : 'maintainer'
}

const initialUser = getUser()
export default new Vuex.Store({
  state: {
    user: initialUser || null,
    role: computeRole(initialUser)
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      state.role = computeRole(user)
      setUser(user)
    },
    CLEAR_USER(state) {
      state.user = null
      state.role = null
    }
  },
  actions: {
    async login({ commit }, { username, password }) {
      const res = await login(username, password)
      const user = res.data
      setToken(user.accessToken)
      commit('SET_USER', user)
      return user
    },
    async loginByPhone({ commit }, { phone, code }) {
      const res = await mobileLogin(phone, code)
      const user = res.data
      setToken(user.accessToken)
      commit('SET_USER', user)
      return user
    },
    logout({ commit }) {
      commit('CLEAR_USER')
      removeToken()
    }
  },
  getters: {
    isAdmin: state => state.role === 'admin',
    isMaintainer: state => state.role === 'maintainer'
  }
})
